export const STAMINA_MAX = 100;
export const STAMINA_RECOVERY = 18;
export const STAMINA_DELAY = 1.2;
export const SWIM_STAMINA_DRAIN = 8;

export function createStaminaRuntime(state) {
  return { last: state.stamina, delay: 0, returning: false };
}

// Endurance uses foreground real seconds, independently of the game clock.
// Walking and steering a boat are gentle activities and allow recovery.
export function stepStamina(state, runtime, seconds, { effort = 0, busy = false } = {}) {
  const dt = Number.isFinite(seconds) ? Math.max(0, Math.min(.1, seconds)) : 0;
  if (!dt) return;
  if (state.stamina < runtime.last - .00001) runtime.delay = STAMINA_DELAY;
  if (effort > 0 || busy) {
    state.stamina = Math.max(0, state.stamina - Math.max(0, effort) * dt);
    runtime.delay = STAMINA_DELAY;
  } else {
    const recoverySeconds = Math.max(0, dt - runtime.delay);
    runtime.delay = Math.max(0, runtime.delay - dt);
    state.stamina = Math.min(STAMINA_MAX, state.stamina + recoverySeconds * STAMINA_RECOVERY);
  }
  runtime.last = state.stamina;
}

export function staminaDisplay(value) {
  const ratio = Math.max(0, Math.min(1, value / STAMINA_MAX));
  return { ratio, visible: ratio < .999, color: ratio <= .2 ? '#f5aa55' : '#8ee15a' };
}
